/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface QaWorstCallModel { 
    callId?: string;
    callDate?: string;
    operatorName?: string;
    operatorPhone?: string;
    clientPhone?: string;
    clientName?: string;
    operatorScore?: number;
    clientSentiment?: string;
    flags?: Array<string>;
    summary?: string;
}

